



































































































































































import { Component, Emit, Model, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Apps from '@/store/modules/Apps';
import Decision from '@/store/modules/Decisions';
import Viewpoints from '@/store/modules/Viewpoints';
import { Urls } from '@/Urls';
import AppNavTreeAddEdit from '@/components/apps/AppsNavTreeAddEdit.vue';
import AppNavTreeAdditionalMenu from '@/components/apps/AppNavTreeAdditionalMenu.vue';

import { v4 as uuidv4 } from 'uuid';
import VuetifyDraggableTreeview from "vuetify-draggable-treeview";
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

Vue.use(VuetifyDraggableTreeview);

const appModule = getModule(Apps);
const viewpointsModule = getModule(Viewpoints);
const decisionModule = getModule(Decision);
const workspaceOptionsModule = getModule(WorkspaceOptions)
@Component({
    components: {
        AppNavTreeAddEdit,
        AppNavTreeAdditionalMenu,
        ConfirmationDialog
    },
})
export default class AppNavTree extends Vue {
    // private selectedMenu = [];
    // private openValues = [];
    private readonly URLS = Urls;
    private openTree = true;
    @Prop({default: false, type: Boolean})
    appEmbed!: boolean;

    @Prop({default: false, type: Boolean})
    isHomepage!: boolean;

    @Prop({default: false, type: Boolean})
    mainApp!: boolean;

    @PropSync('homepagePassed', {default:true, type: Boolean})
    appHomepagePassed!: boolean;

    get appName() {
        return appModule.apps.name;
    }

    get activeItem() {
        return appModule.appsActiveItem;
    }

    get activeAppMenuId() {
        return appModule.activeAppMenuId;
    }

    // set activeItem(activeItem: any) {
    //     appModule.selectActiveItem(activeItem);
    // }

    get selectOpenAppNodes() {
        return appModule.selectOpenAppNodes;
    }

    set selectOpenAppNodes(val: any) {
        appModule.setSelectOpenAppNodes(val);
    }
    get selectedAppId() {
        return appModule.selectedAppId;
    }

    get apps() {
        return appModule.apps;
    }

    get decisionId() {
        return decisionModule.selectedDecisionId;
    }

    get selectedApp() {
        if (this.apps && this.apps.length > 0 && this.selectedAppId != '') {
            return this.apps.find((x) => x.id === this.selectedAppId);
        } else {
            return null;
        }
    }

    get openAll() {
        return true;
    }
    set openAll(newVal) {
        this.openAll = newVal;
    }

    get appsTreeArray() {
        if (this.selectedApp) {
            return this.selectedApp.children;
        } else {
            return null;
        }
    }
    set appsTreeArray(newTreeView:any){
        let apps = this.selectedApp;
        apps.children = newTreeView;
        // console.log(apps);
        appModule.updateApps({decisionId: this.decisionId,appId:apps.id,app:apps})
    }

    private backToHomepage() {
        this.appHomepagePassed = false;
    }

    private selectItem(item) {
        appModule.selectActiveItem(item)
    }

    // delete menu items
    private deleteMenu(item: any) {
        this.removeChildrenMenu(this.selectedApp, item);
        appModule.updateApps({
            decisionId: this.decisionId,
            appId: this.selectedAppId,
            app: this.selectedApp,
        });
    }

    private removeChildrenMenu(parent: any, item: any) {
        if (parent.hasOwnProperty('children') && parent.children.length > 0) {
            let index = parent.children.findIndex((x) => x.id === item.id);
            if (index != -1) {
                parent.children.splice(index, 1);
                return true;
            }
            parent.children.forEach((child: any) => {
                let found = this.removeChildrenMenu(child, item);
                if (found) {
                    return found;
                }
            });
        }
        return false;
    }

    // private async selectActiveViewpoint(viewpointId: string | null = null) {
    //     viewpointsModule.selectActiveViewpoint(viewpointId);
    //     console.log(viewpointId);
    // }

    private async navigateToUrl(item: any) {
        let url = item.href;
        if ( this.appEmbed && appModule.savedStates[item.id] !== undefined ) {
            url = appModule.savedStates[item.id];
        }

        let oldUrl = "";
        if(!this.mainApp){
            if(this.activeItem == null) {
                oldUrl = this.$route.fullPath
            } else {
                oldUrl = this.activeItem.href

            }
            this.appHomepagePassed = true;
            //If new url is forcing state and old url is not forcing state then save snapshot of current state
            if(url.includes('forceState=true') && !oldUrl.includes('forceState=true')) {
                await workspaceOptionsModule.saveState()
            }
            const path = this.getAppsUrl(url);
            appModule.setCurrentAppUrl(path);

            if (this.$route.fullPath !== path) {
                this.$router.push(path);
            }

            //If new url is forcing state, then load the new state from the url
            if(url.includes('forceState=true')) {
                await workspaceOptionsModule.loadStateFromUrl(url);
            }

            //If new url is not forcing state and old url is forcing state then load old snapshot 
            if(!url.includes('forceState=true') && oldUrl.includes('forceState=true')) {
                await workspaceOptionsModule.loadSavedState()
            }
            this.selectItem(item)
        }
    }

    get url() {
        return this.$router.currentRoute.path;
    }

    private getAppsUrl(url: string) {
        // console.log(this.url);
        let mainPath:string;
        if(this.url.substring(0,5).toLowerCase() === '/app2'){
            mainPath = '/app2';
        }else{
            mainPath = '/app2';
        }
        let re = new RegExp(
            '^(http:|https:){1}[/]{2}([a-zA-Z0-9.:-]*[/]{0})([/]{1}[/]*){1}'
        );
        if (re.test(url)) {
            url = mainPath + url.replace(re, '/');
            return url;
        } else {
            return mainPath + url;
        }
    }

    get currentUrl() {
        return workspaceOptionsModule.currentUrl;
    }

    private generateLink(item: any) {
        let link = '';
        link = `http${window.location.hostname === 'localhost' ? '' : 's'}://${
            window.location.host
        }`;
        link = `${link}${this.getAppsUrl(item.href)}`;
        link = `${link}&homepage=${this.selectedApp.homepage && this.selectedApp.showHomepage}&pinnedLeft=true&appEmbedId=${this.selectedAppId}&appEmbedMenuId=${item.id}`
        return link
    }
}
